import PropTypes from 'prop-types';

export default {
  t: PropTypes.func.isRequired,
  formatShortDate: PropTypes.func.isRequired,
  currentLanguage: PropTypes.string.isRequired,
};
